/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import { convertRate, showToast, TOAST_TYPE } from '@utils/utils'
import useRootStore from '@store/useRootStore'
import { MarketTrack } from '@store/matchupStore'
import Login from '@views/Login'
import Type1 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type1'
import Type2 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type2'
import Type3 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type3'
import Type4 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type4'
import Type5 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type5'
import Type6 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type6'
import Type7 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type7'
import Type8 from '@views/Matchup/MatchUpDetail/OutcomeBlockType/Type8'
// img
import { globalStore } from '@store/index'
import { BET_TYPE_ON, CLUB_MEMBER_STATE, MARKET_RENDERING_TYPE } from 'adv-protocol/src/GameCommon'
import { CLUB_JOIN_STATE } from '@constants/index'
import { Schema$MarketBlock, Schema$Outcome } from '@protocol/game'
import { isMobile } from 'react-device-detect'
import { MarketStatusType, ProducerType } from '@game-type/betradar-type'
import {
  ENABLE_MIN_BET_RATE,
  makeSelectionValue,
  Mining,
  replaceOutcomeNameSpec,
} from '@game/util'
import { Radio } from 'antd'
import LockImg from '@assets/images/icon/matchup_icon/outcome-lock.png'
import GuestModePopup from '@views/Popup/GuestModePopup'

export const OUTCOME_CLASS = {
  DEFAULT: 'outcome-name',
  POINT: 'outcome-name point',
}

export const RADIO_GROUP_CLASS = {
  BTN_2_WAY: 'button-2ways',
  BTN_3_WAY: 'button-3ways',
}

export interface OutcomeBlockProps {
  sportId: number
  marketTrack: MarketTrack
  homeTeamName: string
  awayTeamName: string
  tournamentId: number
  matchId: number
  disableMatchScore?: boolean
  minimumLiveMatchOutcomeRate: number
}

export interface TypeProps {
  homeTeamName: string
  awayTeamName: string
  markets: Schema$MarketBlock[]
  initialOutcomeCount: number
  renderOutcomeHeader: (market: Schema$MarketBlock, orders: number[]) => JSX.Element[]
  makeOutcomesElement: (
    market: Schema$MarketBlock, outcomes: Schema$Outcome[], withOutcomeName?: boolean
  ) => JSX.Element[]
  selectedField: string
  renderingType: MARKET_RENDERING_TYPE
  isDisabledMarket: (market: Schema$MarketBlock) => boolean
}

const OutcomeBlock: React.FC<OutcomeBlockProps> = (props: OutcomeBlockProps) => {

  const [selectedField, setSelectedField] = useState('')

  const {
    marketTrack,
    homeTeamName,
    awayTeamName,
    tournamentId,
    matchId,
    disableMatchScore,
    minimumLiveMatchOutcomeRate,
  } = props
  const { matchupStore, authStore } = useRootStore()
  const { cartUpdated } = matchupStore
  const { renderingType, initialOutcomeCount, initialOutcomeNames, markets } = marketTrack

  // debug
  // const printMatchIdAndMarketName = () => {
  //   const targetTeamName = '두산'
  //   if (homeTeamName.indexOf(targetTeamName) > -1 || awayTeamName.indexOf(targetTeamName) > -1) {
  //     console.debug(`matchId: ${matchId}   marketName: ${marketTrack.name}   marketType: ${marketTrack.type}`)
  //   }
  // }

  // debug
  // const printDebugInfo = () => {
  //   const targetMatchId = 24439084
  //   const targetMarketType = 260
  //
  //   if (targetMatchId === _.toNumber(targetMatchId) && marketTrack.type === _.toString(targetMarketType)) {
  //     console.debug(`matchId: ${targetMatchId}   marketName: ${marketTrack.name}   marketType: ${targetMarketType}`)
  //     console.debug(marketTrack)
  //   }
  // }

  // printMatchIdAndMarketName()
  // printDebugInfo()

  useEffect(() => {
    updateSelectedFiled()
  }, [matchId, cartUpdated])

  const updateSelectedFiled = () => {
    const value = matchupStore.getSelectedField(matchId, _.toString(markets[0].type))
    setSelectedField(value)
  }

  const isDisableMarket = (market: Schema$MarketBlock) => {
    return market.status === MarketStatusType.Deactivated
      || market.status === MarketStatusType.Settled
      || market.status === MarketStatusType.HandedOver
  }

  const isDisableOutcome = (market: Schema$MarketBlock, outcome: Schema$Outcome) => {
    const { rate } = outcome
    let disabled = disableMatchScore
      || market.status === MarketStatusType.Suspended
      || outcome.isActive === false
      || _.isNil(rate)
      || rate < ENABLE_MIN_BET_RATE
      || matchupStore.producerId === ProducerType.LIVEODDS && rate < minimumLiveMatchOutcomeRate

    if (!disabled) {
      disabled = (market?.isActiveDueToCombinationRule === false || outcome?.isActiveDueToCombinationRule === false)
    }
    return disabled
  }

  // const isRateUp = outcome => outcome.rate > outcome.oldRate
  //
  // const isRateDown = outcome => outcome.oldRate > outcome.rate

  const makeRateClassName = (market: Schema$MarketBlock, outcome: Schema$Outcome, withOutcomeName?: boolean) => {
    let modifiedClassName = 'radio-button-rate'
    // 배당 변화 애니메이션
    // if (isRateUp(outcome)) {
    //   modifiedClassName += ' rate-up'
    // } else if (isRateDown(outcome)) {
    //   modifiedClassName += ' rate-down'
    // }

    if (withOutcomeName) {
      modifiedClassName += ' float'
    }
    return modifiedClassName
  }

  const makeUniqueKeyByOutcome = (market: Schema$MarketBlock, outcome: Schema$Outcome) => {
    const specifiers = JSON.stringify(market.specifiers)
    return makeSelectionValue({
      marketType: _.toString(market.type),
      specifiers,
      outcomeType: outcome.type,
      rate: outcome.rate,
      outcomeMetaId: outcome.metaId,
      key: outcome.type,
      producerId: matchupStore.producerId,
    })
  }

  const makeViewKeyByOutcome = (market: Schema$MarketBlock, outcome: Schema$Outcome) => {
    return `${market.id}_${market.type}_${outcome.id}_${outcome.type}`
  }

  const makeViewKeyByLockRadioButton = (market: Schema$MarketBlock, outcomePosition: number) => {
    return `${market.id}_${market.type}_${outcomePosition}`
  }

  const makeOutcomeAttributes = (market: Schema$MarketBlock, outcome: Schema$Outcome, withOutcomeName?: boolean) => {
    const viewKey = makeViewKeyByOutcome(market, outcome)
    const value = makeUniqueKeyByOutcome(market, outcome)
    const disabled = isDisableOutcome(market, outcome)
    const rateClassName = makeRateClassName(market, outcome, withOutcomeName)
    const rate = convertRate(authStore.isSignedIn, outcome.rate)
    return {
      viewKey,
      value,
      disabled,
      rateClassName,
      rate,
    }
  }

  const makeOutcomesElement = (
    market: Schema$MarketBlock, outcomes: Schema$Outcome[], withOutcomeName?: boolean,
  ): JSX.Element[] => {
    const elements = []
    if (!isDisableMarket(market)) {
      let index = 0
      for (const outcome of outcomes) {
        if (outcome) {
          const {
            viewKey, value, disabled, rateClassName, rate,
          } = makeOutcomeAttributes(market, outcome, withOutcomeName)
          elements.push((
            <Radio.Button key={viewKey} onClick={onClickOutcome} value={value} disabled={disabled}>
              {withOutcomeName ? <span className="radio-button-outcome-name">{outcome.name}</span> : null}
              <span className={rateClassName}>{rate}</span>
              <img src={LockImg} alt="베팅 불가" className="radio-button-lock"/>
            </Radio.Button>
          ))
        } else {
          const viewKey = makeViewKeyByLockRadioButton(market, index)
          elements.push(makeLockRadioButton(viewKey))
        }
        index += 1
      }
    }``
    return elements
  }

  const renderOutcomeHeader = (market: Schema$MarketBlock, orders: number[]): JSX.Element[] => {
    const header = []
    for (const order of orders) {
      const foundName = initialOutcomeNames.find(object => object.order === order)
      let name = replaceOutcomeNameSpec(foundName.name, homeTeamName, awayTeamName, market.specifiers)
      if (renderingType === MARKET_RENDERING_TYPE.TYPE_3 || renderingType === MARKET_RENDERING_TYPE.TYPE_4) {
        name = _.trim(_.split(name, '/')[0])
      }
      header.push((
        <span key={`${market.id}_${order}`} className={initialOutcomeCount === 3 ? `${RADIO_GROUP_CLASS.BTN_3_WAY} outcome-name--txt` : `${RADIO_GROUP_CLASS.BTN_2_WAY} outcome-name--txt`}>{name}</span>
      ))
    }
    return header
  }

  const onClickOutcome = e => {
    const { club = {} } = matchupStore
    const { isMember, memberState, clubJoinState, name, id: currentClubId, ownerId } = club
    const clubId = currentClubId

    if (!authStore.isSignedIn) {
      globalStore.pushDialogOk({
        custom: <GuestModePopup/>,
        className: 'small-size event',
        callbackCloseDialog: () => {
          globalStore.closeDialog()
          if (isMobile) {
            globalStore.setVisibleSideBar(true)
          } else {
            authStore.showLoginPopup(<Login/>)
          }
        },
      })
      return
    }
    if (!isMember) {
      if (memberState === CLUB_MEMBER_STATE.SEEK_MEMBER) {
        showToast(TOAST_TYPE.INFO, `${name} 클럽 가입 대기 상태입니다.`)
      } else if (clubJoinState === CLUB_JOIN_STATE.DENY) {
        showToast(TOAST_TYPE.INFO, `${name} 클럽 가입 거부 상태입니다.`)
      } else {
        globalStore.pushDialogYesNo({
          title: name,
          text: ['클럽 미가입 상태에서는 베팅할 수 없습니다.', '무료 가입하시겠습니까?'],
          className: 'small-size',
          positivePress: '클럽무료가입',
          negativePress: '취소',
          callbackPositive: () => {
            if (memberState === CLUB_MEMBER_STATE.SEEK_MEMBER || clubJoinState === CLUB_JOIN_STATE.DENY) {
              return
            }
            matchupStore.joinClub(clubId, ownerId)
          },
        })
      }
      return
    }
    if (e.target.value === selectedField) {
      setSelectedField('')
      matchupStore.removeCartItem(tournamentId, matchId, e.target.value)
      return
    }

    const { producerId } = matchupStore

    const [marketType] = e.target.value.split('//')
    if (producerId !== ProducerType.LIVEODDS && !matchupStore.isPossibleMultiBet(matchId, marketType)) {
      matchupStore.setSelectedCartParams(tournamentId, matchId, e.target.value)

      globalStore.pushDialogOk({
        title: '알림',
        text: ['메인 마켓타입과 조합할 수 없습니다.'],
        singlePress: '닫기',
        className: 'small-size',
        callbackCloseDialog: () => {
          globalStore.closeDialog()
        },
        // 뒷배경 클릭 시 닫히도록
        callbackCloseDialogBg: () => {
          globalStore.closeDialog()
        },
      })

      // 동일 경기 선택 모달 (취소 여부)
      // globalStore.toggleSameMatchPopup(true)
      return
    }

    if (producerId !== ProducerType.LIVEODDS && Mining.isRegularMarket(BET_TYPE_ON.UNIFIED_MATCH, marketType)) {
      matchupStore.addCartItem(
        tournamentId,
        matchId,
        e.target.value,
      )
    } else {
      matchupStore.addDetailCartItem(
        tournamentId,
        matchId,
        e.target.value,
      )
    }
  }

  const makeLockRadioButton = (viewKey: string) => {
    return (
      <Radio.Button key={viewKey} onClick={onClickOutcome} disabled>
        <span className="radio-button-rate"/>
        <img src={LockImg} alt="베팅 불가" className="radio-button-lock"/>
      </Radio.Button>
    )
  }

  const isDisabledMarket = (market: Schema$MarketBlock): boolean =>
    market.status === MarketStatusType.HandedOver
    || market.status === MarketStatusType.Settled
    || market.status === MarketStatusType.Cancelled
    || market.status === MarketStatusType.Deactivated
    || market.status === MarketStatusType.Suspended


  const typeProps: TypeProps = {
    homeTeamName,
    awayTeamName,
    markets,
    initialOutcomeCount,
    renderOutcomeHeader,
    makeOutcomesElement,
    selectedField,
    renderingType,
    isDisabledMarket,
  }

  return (
    <Fragment>
      <div className="market-type">

        {renderingType === MARKET_RENDERING_TYPE.TYPE_1 && (
          <Type1 {...typeProps} />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_2 && (
          <Type2 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_3 && (
          <Type3 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_4 && (
          <Type4 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_5 && (
          <Type5 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_6 && (
          <Type6 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_7 && (
          <Type7 {...typeProps}  />
        )}

        {renderingType === MARKET_RENDERING_TYPE.TYPE_8 && (
          <Type8 {...typeProps}  />
        )}

      </div>
    </Fragment>
  )
}

export default observer(OutcomeBlock)
